module.exports = __webpack_public_path__ + "img/folder-minus.f196b263.svg";